import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import Dialog from "./Dialog";
import WindowFunc from "../../ecology9/wea-tools/window";

function noop() {}

function copy(obj, fields) {
  const ret = {};
  fields.forEach(f => {
    if (obj[f] !== undefined) {
      ret[f] = obj[f];
    }
  });
  return ret;
}

class DialogWrap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible
    };
    ["onClose", "onScale", "cleanDialogContainer"].forEach(m => {
      this[m] = this[m].bind(this);
    });
    if (props.visible) {
      window.onWeaDialogOpen && window.onWeaDialogOpen();
    }
  }

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentWillReceiveProps(props) {
    if ("visible" in props) {
      if (this.state.visible !== props.visible) {
        if (props.visible) {
          window.onWeaDialogOpen && window.onWeaDialogOpen();
        } else {
          window.onWeaDialogClose && window.onWeaDialogClose();
        }
      }
      this.setState({
        visible: props.visible
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !!(this.state.visible || nextState.visible);
  }

  componentDidUpdate() {
    if (this.dialogRendered) {
      this.dialogInstance = ReactDOM.unstable_renderSubtreeIntoContainer(
        this,
        this.getDialogElement(),
        this.getDialogContainer()
      );
    }
  }

  componentWillUnmount() {
    const { dialog } = this.props;
    if (this.props.visible) {
      window.onWeaDialogClose && window.onWeaDialogClose();
    }
    if (this.dialogContainer) {
      if (!dialog && this.state.visible) {
        ReactDOM.unstable_renderSubtreeIntoContainer(
          this,
          this.getDialogElement({
            onAfterClose: this.cleanDialogContainer,
            onClose: noop,
            onScale: noop,
            visible: false
          }),
          this.dialogContainer
        );
      } else {
        this.cleanDialogContainer();
      }
    }
  }

  onClose(e) {
    this.props.onClose(e);
  }

  onScale(e, state, height) {
    this.props.onScale(e, state, height);
  }

  getDialogContainer() {
    let { layout = WindowFunc.getTop().document.body } = this.props;

    if (window.setLayoutWindow) {
      layout = window.setLayoutWindow.document.body;
    }
    if (!this.dialogContainer) {
      this.dialogContainer = document.createElement("div");
      layout.appendChild(this.dialogContainer);
    }
    return this.dialogContainer;
  }

  getDialogElement(extra) {
    const props = this.props;
    if (window.setLayoutWindow && window.setDialogFullWindow) {
      let height = $(window.setLayoutWindow.document.body).height();
      if (height < 550) {
        height = 550;
      }
      props.height = height;
      props.width = window.setLayoutWindow.document.documentElement.clientWidth;
      props.draggable = false;
    }
    if (window.height < props.height) {
      props.height = window.height - 50;
    }
    let dialogProps = copy(props, [
      "parentClassName",
      "draggable",
      "className",
      "closable",
      "maskClosable",
      "title",
      "footer",
      "mask",
      "keyboard",
      "animation",
      "transitionName",
      "maskAnimation",
      "maskTransitionName",
      "mousePosition",
      "prefixCls",
      "style",
      "width",
      "wrapStyle",
      "height",
      "zIndex",
      "bodyStyle",
      "wrapClassName",
      "onSpackClick",
      "resize",
      "disableAnimate",
      "scalable",
      "onAfterClose",
      "getRenderModule"
    ]);
    dialogProps = {
      ...dialogProps,
      onClose: this.onClose,
      onScale: this.onScale,
      visible: this.state.visible,
      ...extra
    };
    return (
      <Dialog
        {...dialogProps}
        ecId={`${this.props.ecId}_Dialog@wo4l61`}
        key="dialog"
      >
        {props.children}
      </Dialog>
    );
  }

  getElement(part) {
    return this.dialogInstance.getElement(part);
  }

  cleanDialogContainer() {
    let { layout = WindowFunc.getTop().document.body } = this.props;

    if (window.setLayoutWindow) {
      layout = window.setLayoutWindow.document.body;
    }

    if (this.dialogContainer) {
      ReactDOM.unmountComponentAtNode(this.dialogContainer);
      if (layout.contains(this.dialogContainer)) {
        layout.removeChild(this.dialogContainer);
      }
      this.dialogContainer = null;
    }
  }

  render() {
    this.dialogRendered = this.dialogRendered || this.state.visible;
    return null;
  }
}

DialogWrap.defaultProps = {
  className: "",
  mask: true,
  keyboard: true,
  closable: true,
  scalable: false,
  maskClosable: true,
  prefixCls: "rc-dialog",
  onClose: noop,
  onScale: noop
};

DialogWrap.propTypes = {
  className: PropTypes.string,
  keyboard: PropTypes.bool,
  wrapStyle: PropTypes.object,
  style: PropTypes.object,
  mask: PropTypes.bool,
  closable: PropTypes.bool,
  scalable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  prefixCls: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onScale: PropTypes.func,
  getRenderModule: PropTypes.func
};

export default DialogWrap;



// WEBPACK FOOTER //
// ./_rc-dialog-6.1.1/src/DialogWrap.jsx